'use client';

import { AccountCard } from '@eliadmin/core/src/components/dlz/account/account-card';
import { TextField } from '@eliadmin/core/src/components/dlz/account/profile/profile-fields';
import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/**
 * „Údaje o firme“ of a company customer (`company_buy`). The profile design shows a private person
 * only; the card uses the fields and hints of the registration's company card (60260:30050).
 */
export function CompanyCard() {
  const { t } = useTranslations();

  return (
    <AccountCard title={t('text689')}>
      <div className="grid items-start gap-4 @[40rem]:grid-cols-2">
        <TextField
          name="company"
          label={t('text328')}
          required
          autoComplete="organization"
          placeholder={t('text328')}
        />
        <TextField
          name="ico"
          label={t('text42')}
          required
          inputMode="numeric"
          placeholder={t('text42')}
        />
        <TextField name="dic" label={t('text43')} required placeholder={t('text43')} />
        <TextField
          name="ic_dph"
          label={t('text44')}
          hint={REGISTER_COPY.company.vatHint}
          placeholder={t('text44')}
        />
      </div>
    </AccountCard>
  );
}
